import { RewardUnlockStrategy } from '@brandclub/types';
import { styled, Box, useMediaQuery, Skeleton, Typography } from '@mui/material';
import React__default from 'react';
import '../../analytics/events.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'uuid';
import 'lodash/includes';
import { getAppConsistentParams } from '../../utils/appUtils.js';
import { getDefaultProductImage, getFallbackProductImage, getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '@tanstack/react-query';
import '../../Auth/index.js';
import { CampaignType } from '../../types/Campaign.js';
import { getPurchaseRewardAmountForProduct, getProductUrl } from '../../utils/productUtils.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';
import '../../Components/Animation/AnimationDot.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShareIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/ThumbsDownIcon.js';
import '../../icons/ThumbsUpIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import '../../Components/Button/Button.js';
import '../../Components/Button/CustomDtcBagButton.js';
import '../../Components/BuyBoxDialog/BuyBoxType.js';
import '../../Components/BuyBoxDialog/PriceDialogContent.js';
import '../../Components/BuyBoxDialog/ProductPrice.js';
import { FallbackImage } from '../../Components/FallbackImage.js';
import '../../Components/ImageCropper/ImageCropper.js';
import 'immer';
import '../../Components/automated-theme-setup/DraggableThemeFab.js';
import '@mui/icons-material/ExpandMore';
import '@mui/icons-material/Palette';
import '@mui/icons-material/TextFields';
import '@mui/icons-material/Settings';
import '@mui/icons-material/Notes';
import '@mui/icons-material/SmartButton';
import '@mui/material/styles';
import '../../Components/automated-theme-setup/CustomColorPicker.js';
import 'lodash/merge';
import '@mui/material/CircularProgress';
import 'react-lottie';
import '../../Components/automated-theme-setup/ThemeElementSelector.js';
import '../../Components/Dialog/ResponsiveDialog.js';
import '../components/BrandclubBreadcrumbs/BrandclubBreadcrumbs.js';
import '../components/BrandclubProductCard/index.js';
import '../components/BrandclubVideo.js';
import '../components/PopupDrawer/PopupDrawer.js';
import '../components/ProductPageDialog/ArrowLink.js';
import '../components/BrandclubPhoneInput/index.js';
import '../components/ProductPageDialog/RewardTable.js';
import '../components/ProductPageDialog/SharePage.js';
import '../components/ProductPageDialog/ProductPageDialogContent.js';
import '../components/ProductVariantSelector/index.js';
import '../components/RetailerIconGroup/index.js';
import { RewardPillWithText } from '../components/RewardPill/RewardPillWithText.js';
import '../../types/filters.js';
import '../../types/product.js';
import '../../types/RewardAmountType.js';
import { QuantityControl } from './QuantityControl.js';

const CartProductContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    textDecoration: 'none',
    padding: '20px 0',
    color: theme.vars.palette.text.primary,
    alignItems: 'center',
    gap: 15,
    '.product_image': {
        objectFit: 'contain',
        width: '92px',
        height: '104px',
    },
    '.product_detail': {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        width: '100%',
        gap: 6,
        '.info': {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            [theme.breakpoints.down('sm')]: {
                gap: 4,
            },
            '.retailer_logo': {
                width: 24,
                height: 24,
                img: {
                    width: 24,
                    height: 24,
                    objectFit: 'contain',
                },
            },
            '.price': {
                display: 'flex',
                alignItems: 'center',
                fontSize: 16,
                fontWeight: 600,
                gap: 13,
                [`theme.breakpoints.down('sm')`]: {
                    gap: 11,
                },
            },
            '.name': {
                fontSize: 12,
                fontWeight: 500,
            },
        },
        '.bc-actions': {
            display: 'flex',
            gap: 50,
            marginTop: 5,
            alignItems: 'center',
            justifyContent: 'space-between',
            '.quantity': {},
            '.remove': {
                fontSize: 14,
                fontWeight: 500,
                '&:hover': {
                    cursor: 'pointer',
                    textDecoration: 'underline',
                },
            },
        },
    },
    '&.large': {
        gap: 30,
        [`theme.breakpoints.down('sm')`]: {
            gap: 25,
        },
        '.product_image': {
            width: 115,
            height: 115,
            [`theme.breakpoints.down('sm')`]: {
                width: '92px',
                height: '104px',
            },
        },
        '.product_detail': {
            gap: 10,
            [`theme.breakpoints.down('sm')`]: {
                gap: 6,
            },
            '.info': {
                '.price': {
                    fontWeight: 600,
                    fontSize: 16,
                },
                '.name': {
                    fontWeight: 500,
                    fontSize: 14,
                },
            },
            '.bc-actions': {
                justifyContent: 'space-between',
                '.remove': {
                    fontWeight: 500,
                    fontSize: 14,
                    [`theme.breakpoints.down('sm')`]: {
                        fontSize: 12,
                    },
                },
            },
        },
    },
}));
const CartProduct = ({ large = false, product, className, disabled = false, editable = true, handleAddQuantity, handleMinusQuantity, cartProducts, storeBrandingType, }) => {
    var _a, _b, _c;
    const cartProduct = cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts[product.stacklineSku];
    const metadata = cartProduct !== null && cartProduct !== void 0 ? cartProduct : product;
    // hasActiveInstantReward on metadata is not always set, so we need to check the campaignRewards as well
    const hasActiveInstantReward = !!(metadata === null || metadata === void 0 ? void 0 : metadata.hasActiveInstantReward) ||
        (!!(metadata === null || metadata === void 0 ? void 0 : metadata.campaignRewards) &&
            (metadata === null || metadata === void 0 ? void 0 : metadata.campaignRewards.some((campaignReward) => (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                (campaignReward &&
                    'rewardUnlockStrategy' in campaignReward &&
                    campaignReward.rewardUnlockStrategy === RewardUnlockStrategy.Instant))));
    const rewardAmount = metadata && getPurchaseRewardAmountForProduct(metadata);
    const rewardPercent = !!(metadata === null || metadata === void 0 ? void 0 : metadata.retailPrice) && !!rewardAmount ? (rewardAmount * 100) / metadata.retailPrice : 0;
    const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const urlSearchParams = getAppConsistentParams(window.location.search);
    if (!(metadata === null || metadata === void 0 ? void 0 : metadata.title)) {
        return (React__default.createElement(CartProductContainer, { className: 'cart_product' },
            React__default.createElement(Skeleton, { className: "product_image" }),
            React__default.createElement(Box, { className: "product_detail" },
                React__default.createElement(Box, { className: "info" },
                    React__default.createElement(Skeleton, { className: "price" }),
                    React__default.createElement(Skeleton, { className: "name" })))));
    }
    return (React__default.createElement(CartProductContainer, { className: [large && 'large', className].filter(Boolean).join(' ') + ' cart_product' },
        React__default.createElement("a", { href: getProductUrl({
                title: metadata.title,
                stacklineSku: metadata.stacklineSku,
                urlSearchParams,
                dtcProductPageUrl: metadata.dtcProductPageUrl,
                storeType: storeBrandingType,
            }), style: { textDecoration: 'none' }, target: "_blank" },
            React__default.createElement(Box, null,
                React__default.createElement(FallbackImage, { title: (_a = metadata === null || metadata === void 0 ? void 0 : metadata.title) !== null && _a !== void 0 ? _a : product.stacklineSku, className: "product_image", src: getDefaultProductImage((product === null || product === void 0 ? void 0 : product.stacklineSku) || ''), fallbackImage: getFallbackProductImage((product === null || product === void 0 ? void 0 : product.stacklineSku) || '') }))),
        React__default.createElement(Box, { className: 'product_detail' },
            React__default.createElement(Box, { className: 'info' },
                React__default.createElement(Box, { className: 'price' },
                    React__default.createElement(Box, { className: 'retailer_logo' },
                        React__default.createElement("img", { src: getEntityImage(product.retailerId, 'retailer'), alt: `Logo for retailer: ${product.retailerId}` })),
                    formatMoney((_b = metadata === null || metadata === void 0 ? void 0 : metadata.retailPrice) !== null && _b !== void 0 ? _b : product.retailPrice),
                    !!rewardAmount && (React__default.createElement(RewardPillWithText, { rewardAmount: rewardAmount, rewardPercentText: "reward", baseFontSize: isMobileView ? 12 : 14, pillContainerStyle: {
                            boxSizing: 'border-box',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }, rewardPercent: rewardPercent, rewardCampaignType: hasActiveInstantReward ? CampaignType.DailyDealsRewardCampaign : CampaignType.PurchaseRewardCampaign }))),
                React__default.createElement(Typography, { className: 'name', title: metadata === null || metadata === void 0 ? void 0 : metadata.title, sx: {
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                    } }, (_c = metadata === null || metadata === void 0 ? void 0 : metadata.title) !== null && _c !== void 0 ? _c : 'Unknown Product')),
            editable && (React__default.createElement(Box, { className: 'bc-actions' },
                React__default.createElement(Box, null,
                    React__default.createElement(QuantityControl, { large: large, disabled: disabled, count: product.quantity, onAddClick: () => handleAddQuantity(product), onMinusClick: () => handleMinusQuantity(product), trackedParams: product })))))));
};

export { CartProduct };
//# sourceMappingURL=CartProduct.js.map
